// utils/idb.js
import { openDB } from 'idb';

const DB_NAME = 'consultation-recorder_v1';
const DB_VERSION = 2; // <- must be >= the existing on-disk version

export async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db, oldVersion, newVersion, transaction) {
      // v1: initial schema
      if (oldVersion < 1) {
        if (!db.objectStoreNames.contains('sessions')) {
          db.createObjectStore('sessions'); // key: sessionId -> manifest
        }
        if (!db.objectStoreNames.contains('segments')) {
          db.createObjectStore('segments'); // key: segmentId -> Blob
        }
        if (!db.objectStoreNames.contains('ui')) {
          db.createObjectStore('ui');       // key: 'pendingGroups' -> value
        }
      }

      // v2: (example) future migrations go here
      if (oldVersion < 2) {
        // e.g., add new store or index:
        // if (!db.objectStoreNames.contains('analytics')) {
        //   db.createObjectStore('analytics');
        // }
      }
    },
    blocked() {
      // Optional: another tab still has the old version open
      // Consider notifying the user to close other tabs.
    },
    blocking() {
      // Optional: this tab is blocking a newer open elsewhere
    },
    terminated() {
      // Optional: the connection was unexpectedly closed
    }
  });
}

export async function idbPut(store, key, val) {
  const db = await getDB();
  return db.put(store, val, key);
}

export async function idbGet(store, key) {
  const db = await getDB();
  return db.get(store, key);
}

export async function idbDelete(store, key) {
  const db = await getDB();
  return db.delete(store, key);
}

export async function idbKeys(store) {
  const db = await getDB();
  return db.getAllKeys(store);
}
